import React from 'react';

const CardForMapping = ({ color, title, displayTitle = true, subtitle, subtext, children }) => {
  return (
    <div className="card">
      {displayTitle && (
        <div className="card-header card-header-text" data-background-color={color}>
          <h6 className="card-title pb-0 mb-0 text-capitalise">{title}</h6>
        </div>
      )}
      <div className="card-content pb-4">
        <div className="card-title-header">
          <h4 className="card-title">
            {subtitle && subtitle}
            {subtext && (
              <>
                <br></br>
                <small>{subtext}</small>
              </>
            )}
          </h4>
          <div className="card-cta"></div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default CardForMapping;
